package org.ttt.autogenesis.kvisionapp.audio

import org.ttt.autogenesis.network.*
import kotlinx.serialization.builtins.*

internal fun registerAudioClientHandlersRpcHandlers(rpcRegistry : RpcRegistry, target : org.ttt.autogenesis.kvisionapp.audio.AudioClientHandlers)
{

    rpcRegistry.registerTyped(
        method = "audio.channelUpdate",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.audio.AudioChannelUpdate.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleChannelUpdate(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "audio.musicSchedule",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.audio.AudioMusicSchedule.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleMusicSchedule(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "audio.paramUpdate",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.audio.AudioParamUpdate.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleParamUpdate(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "audio.queryState",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.audio.AudioQueryState.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleQueryState(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "audio.schedulePlay",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.audio.AudioSchedulePlay.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleSchedulePlay(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "audio.stop",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.audio.AudioStop.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleStop(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "audio.syncState",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.audio.AudioSyncState.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleSyncState(ctx, payload)
        null
    }
}

internal class AudioClientHandlersRpcHandlersRegistrationProvider(private val target : org.ttt.autogenesis.kvisionapp.audio.AudioClientHandlers) : RpcRegistrationProvider
{
    override fun register(rpcRegistry : RpcRegistry)
    {
        registerAudioClientHandlersRpcHandlers(rpcRegistry, target)
    }
}

internal val _audioClientHandlersRpcHandlersProvider = AudioClientHandlersRpcHandlersRegistrationProvider(org.ttt.autogenesis.kvisionapp.audio.AudioClientHandlers).also {
    RpcRegistrationCollector.registerProvider(it)
}
